import { render, staticRenderFns } from "./BaseRadioLikeCheckbox.vue?vue&type=template&id=eb1fb53c"
import script from "./BaseRadioLikeCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseRadioLikeCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports